// Sidebar del paciente para viewport desktop (lg:). En mobile queda oculto —
// el PacienteBottomNav sigue siendo la nav mobile (patrón fixed bottom nav
// pre-existente). No requiere drawer mobile porque el bottom nav ya cubre.
//
// Items reused de PacienteBottomNav (Inicio / Progreso / Historial / Perfil):
// mismos paths, mismos labels, mismos íconos. Active state derivado de
// useLocation (patrón 1:1 pathname del bottom nav — cada item corresponde
// a exactamente 1 URL).
//
// Tokens `bg-sidebar / border-sidebar-border / text-sidebar-foreground`
// del theme para consistencia visual con KineSidebar. El logo/branding
// queda inline en el header de HomePaciente (extraer a PacienteHeader
// shared queda como follow-up cuando aparezca el 3er uso — hoy solo
// HomePaciente es responsive, ProgresoPaciente/HistorialSesiones/
// PerfilPaciente quedan en deuda técnica).

import { Link, useLocation } from "react-router";
import { Clock, Home, TrendingUp, User } from "lucide-react";

interface SidebarItem {
  path: string;
  Icon: typeof Home;
  label: string;
}

const items: SidebarItem[] = [
  { path: "/paciente-home", Icon: Home, label: "Inicio" },
  { path: "/progreso", Icon: TrendingUp, label: "Progreso" },
  { path: "/historial", Icon: Clock, label: "Historial" },
  { path: "/perfil", Icon: User, label: "Perfil" },
];

export function PacienteSidebar() {
  const { pathname } = useLocation();

  return (
    <aside className="hidden lg:block w-56 bg-sidebar border-r border-sidebar-border min-h-screen p-4 shrink-0">
      <div className="space-y-1">
        {items.map((item) => {
          const on = item.path === pathname;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ease-out ${
                on
                  ? "bg-primary text-primary-foreground font-semibold shadow-md"
                  : "hover:bg-sidebar-accent text-sidebar-foreground"
              }`}
            >
              <item.Icon className="w-5 h-5" strokeWidth={1.5} />
              <span className="flex-1">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </aside>
  );
}
